import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useEffect } from "react";
import { useConfetti } from "../../../hooks/useConfetti";

export default function QuizPopup({
  openModal,
  setOpenModal,
  heading,
  text,
  coinAmount,
}) {
  const [confettiRef, confetti] = useConfetti();

  useEffect(() => {
    if (openModal) {
      confetti();
    }
  }, [openModal]);
  return (
    <div>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        as="div"
        className="fixed inset-0 z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto md:mt-28 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div
          ref={confettiRef}
          className="absolute top-1/4 z-20 flex w-[80%] flex-col items-center justify-center rounded-lg bg-white py-5 px-3 md:top-20 md:w-1/3"
        >
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src="https://img.learntube.ai/public-assets/Content_player/quizCompleteEmoji.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657260994143"
            className="h-20 w-20 md:h-16 md:w-16"
            transformation={[
              {
                height: "160",
                width: "160",
              },
            ]}
          />
          <h2 className="mt-6 mb-2 text-2xl font-bold">{heading}</h2>
          <p className="text-center">
            {text}
            <br />
            You earn{" "}
            <span className="font-semibold text-amber-500">
              {coinAmount} coins.
            </span>
          </p>
          <button
            className="mt-6 w-[90%] rounded bg-[#FDBF48] py-2.5 px-3 font-semibold md:w-40"
            onClick={() => setOpenModal(false)}
          >
            Got it!
          </button>
        </div>
      </Dialog>
    </div>
  );
}
